import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserClaims } from '@mitel/cloudlink-sdk';
import { Subscription } from 'rxjs';
import { AppUserClaimsService } from '../services/app-user-claims.service';
import { Account } from '@mitel/cloudlink-sdk/admin';

@Component({
  selector: 'app-flows',
  templateUrl: './flows.component.html',
  styleUrls: ['./flows.component.css']
})
export class FlowsComponent implements OnInit, OnDestroy {
  rightPanelOpened = false;
  columns = [
    {
        header: 'NAME',
        field: 'name',
        sortable: true,
        sorted: true,
        queryFields : ['name'],
        sortBy: ['name'],
        widthPercent: 35
    },
    {
        header: 'TYPE',
        field: 'componentType',
        sortable: true,
        sorted: false,
        queryFields : ['componentType'],
        sortBy: ['componentType'],
        widthPercent: 20,
    },
    {
        header: 'PHONE NUMBER & EXT.',
        field: 'tn',
        sortable: true,
        sorted: false,
        queryFields : ['tn', 'extension'],
        sortBy: ['tn'],
        widthPercent: 25,
    },
    {
        header: 'LOCATION',
        field: 'locationName',
        sortable: true,
        sorted: false,
        queryFields : ['locationUuid', 'locationName'],
        sortBy: ['locationName'],
        widthPercent: 15,
    },
];
claims: UserClaims;
company: Account;

claimsChangedSubscription: Subscription;
companyChangedSubscription: Subscription;

constructor(private appSvc: AppUserClaimsService) { }

ngOnInit() {
  this.claimsChangedSubscription = this.appSvc.claimsChanged.subscribe(claims => {
    this.claims = claims;
  });

  this.claims = this.appSvc.getClaims();

  this.companyChangedSubscription = this.appSvc.companyChanged.subscribe(company => {
    this.company = company;
    });

    this.company = this.appSvc.getCompany();

  }

  rightPanelOpenedHandler(panelOpened: boolean) {
    this.rightPanelOpened = panelOpened;
  }

  ngOnDestroy() {
    if (this.claimsChangedSubscription) {
        this.claimsChangedSubscription.unsubscribe();
    }
    if (this.companyChangedSubscription) {
        this.companyChangedSubscription.unsubscribe();
    }

}

}
